import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** Represents a container's aggregated properties, for example, weight, and volume. */
export type AggregateProperty = {
  __typename?: 'AggregateProperty';
  /** Container volume property. */
  volumeProperty?: Maybe<VolumeProperty>;
  /** Container weight property. */
  weightProperty?: Maybe<WeightProperty>;
};

export type AllowedContainerType = {
  __typename?: 'AllowedContainerType';
  containerType: Scalars['String'];
  isPresentInPerfectNode: Scalars['Boolean'];
  isPresentInVinyaas: Scalars['Boolean'];
  isReusable: Scalars['Boolean'];
};

/** Represents a AreSiblingsInput object for the list of scannables to check for a common parent */
export type AreSiblingsInput = {
  /** List of scannableIds to check for a common parent container. */
  scannables: Array<Scalars['String']>;
};

/** Represents a AreSiblingsOutput object for the common parent container for the given scannables */
export type AreSiblingsOutput = {
  __typename?: 'AreSiblingsOutput';
  /** Container type of the parent scannable, for example "BAG". */
  containerType: Scalars['String'];
  /** Single scannable for the parent container. */
  scannable: Scalars['String'];
};

/** Represents AuditWorkAndMoveContainerInput object for the given container. */
export type AuditWorkAndMoveContainerInput = {
  /** Destination container's scannable */
  destinationScannable: Scalars['String'];
  /** exportNodeID(previous facility) from which the container got departed. */
  exportNodeId: Scalars['String'];
  /** flightNumber info of a trailer in which the container arrived. */
  flightNumber: Scalars['String'];
  /** Source container's scannable */
  sourceScannable: Scalars['String'];
  /** trailerID info of a trailer in which the container arrived. */
  trailerId: Scalars['String'];
};

/** Represents a AuditWorkAndMoveContainerOutput object for the container that was closed */
export type AuditWorkAndMoveContainerOutput = {
  __typename?: 'AuditWorkAndMoveContainerOutput';
  /** Single scannable for the container */
  scannable: Scalars['String'];
};

/** Represents a CandidateDestinationContainers object */
export type CandidateDestinationContainers = {
  __typename?: 'CandidateDestinationContainers';
  /** Destination container type */
  containerType: Scalars['String'];
  /** Destination containers' label list */
  labels: Array<Scalars['String']>;
};

/** Represents a ChildCountAuditInput object */
export type ChildCountAuditInput = {
  /** One of the scannables of the container. */
  scannable: Scalars['String'];
  /** User count of the packages */
  userPackageCount: Scalars['String'];
};

/** Represents a ChildCountAuditOutput object */
export type ChildCountAuditOutput = {
  __typename?: 'ChildCountAuditOutput';
  /** Message of the result */
  message?: Maybe<Scalars['String']>;
};

/** Represents a CloseContainerInput object for the container to be closed */
export type CloseContainerInput = {
  /** Single scannable for the container. */
  scannable: Scalars['String'];
};

/** Represents a CloseContainerOutput object for the container that was closed */
export type CloseContainerOutput = {
  __typename?: 'CloseContainerOutput';
  /** Container type of the scannable, for example "BAG". */
  containerType: Scalars['String'];
  /** Single scannable for the container. */
  scannable: Scalars['String'];
};

/** Represents CompleteContainerArrivalWorkInput object for the given container. */
export type CompleteContainerArrivalWorkInput = {
  /** Container type of the scannable, for example "BAG". */
  containerType: Scalars['String'];
  /** container's scannable */
  scannable: Scalars['String'];
};

/** Represents a CompleteContainerArrivalWorkOutput object for the container that was closed */
export type CompleteContainerArrivalWorkOutput = {
  __typename?: 'CompleteContainerArrivalWorkOutput';
  /** container's scannable */
  scannable: Scalars['String'];
};

/** Represents a CompleteDirectedMoveTaskInput object */
export type CompleteDirectedMoveTaskInput = {
  /** The reason a task is abandoned by the Associate. */
  abandonReason?: InputMaybe<Scalars['String']>;
  /** DCM task request time */
  completionStatus: Scalars['String'];
  /** The reason a task cannot be completed. */
  exceptionReason?: InputMaybe<Scalars['String']>;
  /** resource scannable id */
  leftAtResourceId: Scalars['String'];
  /** DCM task request id */
  requestId: Scalars['String'];
};

/** Represents a CompleteDirectedMoveTaskOutput object */
export type CompleteDirectedMoveTaskOutput = {
  __typename?: 'CompleteDirectedMoveTaskOutput';
  /** The reason a task is abandoned by the Associate. */
  abandonReason?: Maybe<Scalars['String']>;
  /** completed time */
  completedTime: Scalars['String'];
  /** DCM task request time */
  completionStatus: Scalars['String'];
  /** The reason a task cannot be completed. */
  exceptionReason?: Maybe<Scalars['String']>;
  /** resource scannable id */
  leftAtResourceId: Scalars['String'];
  /** DCM task request id */
  requestId: Scalars['String'];
  /** result message */
  resultMessage: Scalars['String'];
};

/** Represents a Container. */
export type Container = {
  __typename?: 'Container';
  /** The UUID of the container. */
  id?: Maybe<Scalars['String']>;
  /** Label of the container. */
  label?: Maybe<Scalars['String']>;
  /** Scannables of the container. */
  scannables?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Container type of the container. */
  type?: Maybe<Scalars['String']>;
};

/** Represents container attributes. */
export type ContainerAttributes = {
  __typename?: 'ContainerAttributes';
  /** The critical pull time. */
  cpt?: Maybe<Scalars['String']>;
  /** The stacking filter. */
  stackingFilter?: Maybe<Scalars['String']>;
};

export type ContainerHierarchyInfo = {
  __typename?: 'ContainerHierarchyInfo';
  /** Compound container's number of children package, default is 0. */
  packageChildrenCount: Scalars['Int'];
  /**
   * Container's parent container scannable.
   * Set to nullable, because could be null if a container has no parent.
   */
  parentContainerScannable?: Maybe<Scalars['String']>;
};

/** Represents the input for the create container API. */
export type CreateContainerInput = {
  /** Container type of the new container to be created. */
  containerType: Scalars['String'];
  /** Optional flag to override validation checks */
  overrideValidation?: InputMaybe<Scalars['Boolean']>;
  /** Scannable of the destination parent container. */
  parentScannable: Scalars['String'];
  /**
   * Optional scannable for the new container. If not provided, the scannable will be
   * generated by the create container API.
   */
  scannable?: InputMaybe<Scalars['String']>;
};

/** Represents the output for the create container API. */
export type CreateContainerOutput = {
  __typename?: 'CreateContainerOutput';
  /** Container type of the newly created container. */
  containerType: Scalars['String'];
  /** Scannable of the newly created container. */
  scannable: Scalars['String'];
};

/**
 * Represents a EmitMetricsInput object to emit metrics. All metrics are validated server-side.
 * Limitations are described below for each field.
 */
export type EmitMetricsInput = {
  /**
   * The metrics to be emitted; supports multiple metrics emitted through a single request.
   * Limit: 5 Metrics
   */
  metrics: Array<Metric>;
  /**
   * The name of the workflow if the metric is within a workflow. Otherwise null is acceptable.
   * Limit: 128 characters
   */
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Represents a EmitMetricsOutput object, containing the names of each of the metrics emitted. */
export type EmitMetricsOutput = {
  __typename?: 'EmitMetricsOutput';
  /** The names of the metrics emitted. */
  metricNames: Array<Scalars['String']>;
};

/** Represents a GetDestinationsForContainerInput object */
export type GetDestinationsForContainerInput = {
  /** Container's scannable */
  scannable: Scalars['String'];
};

/** Represents a GetDestinationsForContainerOutput object */
export type GetDestinationsForContainerOutput = {
  __typename?: 'GetDestinationsForContainerOutput';
  /** Candidate destination container list ordered by container type */
  candidateDestinationContainers: Array<CandidateDestinationContainers>;
  /** Whether current node needs to show static destination message */
  isShowStaticDestinationMessage: Scalars['Boolean'];
};

/** Represents a GetMessagesOutput object which contains the list of pending messages for the user. */
export type GetMessagesOutput = {
  __typename?: 'GetMessagesOutput';
  /** List of messages for the user. */
  messages: Array<Message>;
};

/** Compound container's hazmat information, for example, if this compound container has hazmat. */
export type HazmatInfo = {
  __typename?: 'HazmatInfo';
  hasHazmat: Scalars['Boolean'];
};

/** Uniquely identifies a container. */
export type IdentifyContainerInput = {
  /** One of the scannables of the container. */
  scannable: Scalars['String'];
};

/** Represents a container, for example gaylord or package. */
export type IdentifyContainerOutput = {
  __typename?: 'IdentifyContainerOutput';
  /**
   * Container Aggregated Properties, for example, weight and volume.
   * Set to nullable, because if SCMS does not have correct aggregateProperty in CPI, it will return null.
   */
  aggregateProperty?: Maybe<AggregateProperty>;
  /** Unique id for this container. */
  containerId: Scalars['String'];
  /** Display label for the container. */
  containerLabel: Scalars['String'];
  /** Type of the container, for example "BAG". */
  containerType: Scalars['String'];
  /** Critical Pull Time for this container. The last possible time the package can be loaded for delivery. */
  cpt?: Maybe<Scalars['String']>;
  /** Compound container's hazmat information, for example, if this compound container has hazmat. */
  hazmatInfo?: Maybe<HazmatInfo>;
  /** Hierarchy information for the container, composed of parent and child container information. */
  hierarchyInfo?: Maybe<ContainerHierarchyInfo>;
  /**
   * Lane is a parent of stacking filters. There are multiple stacking filters mapped to the same lane.
   * Conveyor belts sort incoming packages to a lane where associates use the visual sortation marker to move the
   * package into the correct destination container.
   */
  lane?: Maybe<Scalars['String']>;
  /** List of scannables (barcodes) for the container, default is []. */
  scannables: Array<Maybe<Scalars['String']>>;
  /** Stacking Filter for this container. A tag associated with a container capturing the intent on how it should be sorted. */
  stackingFilter?: Maybe<Scalars['String']>;
  /** Visual Sortation Marker for this container. Label used by associates to identify the destination container. */
  vsm?: Maybe<Scalars['String']>;
};

/** Represents a MergeContainerInput object */
export type MergeContainerInput = {
  /** Optional flag to inherit the source container's stacking filter to the destination container on merge. Default: false */
  destinationInheritsStackingFilterFromSource?: InputMaybe<Scalars['Boolean']>;
  /** Destination container's scannable */
  destinationScannable: Scalars['String'];
  /** Optional flag to prevent the source container from being deleted on merge. Default: false */
  keepSourceContainer?: InputMaybe<Scalars['Boolean']>;
  /** Whether this merge process is force merge */
  overrideValidation: Scalars['Boolean'];
  /** Source container's scannable */
  sourceScannable: Scalars['String'];
};

/** Represents a MergeContainerOutput object */
export type MergeContainerOutput = {
  __typename?: 'MergeContainerOutput';
  /** Destination container. */
  destinationContainer: Container;
  /** Source container. */
  sourceContainer: Container;
};

/** Represents an unread message for the user. */
export type Message = {
  __typename?: 'Message';
  /** Unique Id of the message for the recipient. */
  messageRecipientId: Scalars['String'];
  /** Message body. */
  messageText: Scalars['String'];
  /** Login name (alias) of the message's sender. */
  submitterId: Scalars['String'];
};

/** Represents the Metric input type. */
export type Metric = {
  /**
   * A nullable field providing context about the metrics; a JSON blob.
   * Limit: 1024 characters
   */
  context?: InputMaybe<Scalars['String']>;
  /**
   * The name of the metric.
   * Limit: 128 characters
   */
  name: Scalars['String'];
  /** The value of the metric. */
  value: Scalars['Float'];
};

/** Represents a MoveContainerInput object */
export type MoveContainerInput = {
  /** Destination container's scannable */
  destinationScannable: Scalars['String'];
  /** Whether this move process is force move */
  overrideValidation: Scalars['Boolean'];
  /** Source container's scannable */
  sourceScannable: Scalars['String'];
};

/** Represents a MoveContainerOutput object */
export type MoveContainerOutput = {
  __typename?: 'MoveContainerOutput';
  /** Destination container's scannable */
  destinationScannable: Scalars['String'];
  /** Source container's scannable */
  sourceScannable: Scalars['String'];
};

/** A root type for mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Audit work of source container and move it to destination container */
  auditWorkAndMoveContainer?: Maybe<AuditWorkAndMoveContainerOutput>;
  /** Close the container with the given scannable */
  closeContainer?: Maybe<CloseContainerOutput>;
  /** Complete arrival work of the container. */
  completeContainerArrivalWork?: Maybe<CompleteContainerArrivalWorkOutput>;
  /** Complete directed container movement task */
  completeDirectedMoveTask?: Maybe<CompleteDirectedMoveTaskOutput>;
  /** Creates a new container with the given container type at a destination. */
  createContainer: CreateContainerOutput;
  /** Creates numerical feedback entry */
  createNumFeedback?: Maybe<NumFeedback>;
  /** Creates text feedback entry */
  createTextFeedback?: Maybe<TextFeedback>;
  /**
   * Emit metrics.
   * Validation will occur on server-LEVEL_side. Any and all metrics that fail validation will
   * not be emitted. Only the metrics emitted (and pass validation) will be in the output.
   * See EmitMetricsInput schema for details about fields and limitations.
   */
  emitMetrics: EmitMetricsOutput;
  /** Merge source container to destination container */
  mergeContainer?: Maybe<MergeContainerOutput>;
  /** Move source container to destination container */
  moveContainer?: Maybe<MoveContainerOutput>;
  /** Prints a label for the given container. Supports both elemental and compound containers. */
  printLabel: PrintLabelOutput;
  /** Send Web Vitals metric */
  sendWebVitalsMetric: SendWebVitalsMetricOutput;
  /** Swaps a directed move task for a different directed move task. */
  swapDirectedWork?: Maybe<SwapDirectedWorkOutput>;
  /** Update the status of a message that the user received. */
  updateMessage: UpdateMessageOutput;
  /** Update status of directed container movement task */
  updateWorkStatus: UpdateWorkStatusOutput;
};


/** A root type for mutations */
export type MutationAuditWorkAndMoveContainerArgs = {
  input: AuditWorkAndMoveContainerInput;
};


/** A root type for mutations */
export type MutationCloseContainerArgs = {
  input: CloseContainerInput;
};


/** A root type for mutations */
export type MutationCompleteContainerArrivalWorkArgs = {
  input: CompleteContainerArrivalWorkInput;
};


/** A root type for mutations */
export type MutationCompleteDirectedMoveTaskArgs = {
  input: CompleteDirectedMoveTaskInput;
};


/** A root type for mutations */
export type MutationCreateContainerArgs = {
  input: CreateContainerInput;
};


/** A root type for mutations */
export type MutationCreateNumFeedbackArgs = {
  input?: InputMaybe<NumFeedbackInput>;
  metric: Scalars['String'];
  question: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  score: Scalars['Int'];
};


/** A root type for mutations */
export type MutationCreateTextFeedbackArgs = {
  feedback: Scalars['String'];
  input?: InputMaybe<TextFeedbackInput>;
  role?: InputMaybe<Scalars['String']>;
  topic: Scalars['String'];
};


/** A root type for mutations */
export type MutationEmitMetricsArgs = {
  input: EmitMetricsInput;
};


/** A root type for mutations */
export type MutationMergeContainerArgs = {
  input: MergeContainerInput;
};


/** A root type for mutations */
export type MutationMoveContainerArgs = {
  input: MoveContainerInput;
};


/** A root type for mutations */
export type MutationPrintLabelArgs = {
  input: PrintLabelInput;
};


/** A root type for mutations */
export type MutationSendWebVitalsMetricArgs = {
  input: SendWebVitalsMetricInput;
};


/** A root type for mutations */
export type MutationSwapDirectedWorkArgs = {
  input: SwapDirectedWorkInput;
};


/** A root type for mutations */
export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


/** A root type for mutations */
export type MutationUpdateWorkStatusArgs = {
  input: UpdateWorkStatusInput;
};

/** Represents the request payload we pass for getting next task. */
export type NextDirectedMoveTaskInput = {
  /**
   * Roles assigned to the user.
   * Deprecated: This input is not used anymore.
   */
  userSelectedRoleName?: InputMaybe<Scalars['String']>;
};

/**
 * Represents a NextDirectedMoveTaskOutput object
 * Currently, DCM provides below 2 resultMessage values:
 * - SUCCESS => When DCM task is available, then all the fields will be provided
 * - NO_REQUESTS_AVAILABLE => When no DCM task is available, rest all the fields will be null.
 */
export type NextDirectedMoveTaskOutput = {
  __typename?: 'NextDirectedMoveTaskOutput';
  /** container id to move - UUID */
  containerId?: Maybe<Scalars['String']>;
  /** container scannable to move - also to display label */
  containerScannable?: Maybe<Scalars['String']>;
  /** container type to move */
  containerType?: Maybe<Scalars['String']>;
  /** The critical pull time. */
  cpt?: Maybe<Scalars['String']>;
  /** Label of destination resource to which source should be moved */
  destinationResourceLabel?: Maybe<Scalars['String']>;
  /** destination resource scannable id */
  destinationResourceScannableId?: Maybe<Scalars['String']>;
  /** Type of destination resource to which source should be moved */
  destinationResourceType?: Maybe<Scalars['String']>;
  /** The color of the light on the container. */
  lightColor?: Maybe<Scalars['String']>;
  /**
   * The state of the light. Possible states are: on, none, error
   * * on - The light is available and is on. See the LightColor field.
   * * none - The container does not support a light or is not installed.
   * * error - The container supports a light, but an error occurred when turning it on.
   * * unknown - The light is on, but is an unsupported color.
   */
  lightState?: Maybe<Scalars['String']>;
  /** The time the task needs to be completed. */
  needByTime?: Maybe<Scalars['String']>;
  /** The reason the task needs to be completed by the time. */
  needByTimeReason?: Maybe<Scalars['String']>;
  /**
   * reason to move
   * @deprecated Use new field `workAssignmentReason`.
   */
  reasonCode?: Maybe<Scalars['String']>;
  /** DCM task request id */
  requestId?: Maybe<Scalars['String']>;
  /** DCM task request time */
  requestTime?: Maybe<Scalars['String']>;
  /**
   * resource display label
   * @deprecated Use new field `sourceResourceLabel`.
   */
  resourceLabel?: Maybe<Scalars['String']>;
  /** result message */
  resultMessage: Scalars['String'];
  /** resource display label */
  sourceResourceLabel?: Maybe<Scalars['String']>;
  /** source resource scannable id */
  sourceResourceScannableId?: Maybe<Scalars['String']>;
  /** Type of resource to which source is present */
  sourceResourceType?: Maybe<Scalars['String']>;
  /** The stacking filter. */
  stackingFilter?: Maybe<Scalars['String']>;
  /** reason to move */
  workAssignmentReason?: Maybe<Scalars['String']>;
  /** work type of the dcm task */
  workType?: Maybe<Scalars['String']>;
};

/** Represents a NodeConfigOutput object for the map of configurations at the specified node */
export type NodeConfigOutput = {
  __typename?: 'NodeConfigOutput';
  /** The Map of configurations to their boolean converted to JSON. */
  nodeConfigurations: Scalars['String'];
};

/** Represents a feedback object */
export type NumFeedback = {
  __typename?: 'NumFeedback';
  /** Question asked on feedback form */
  question: Scalars['String'];
  /** Score of feedback response */
  score: Scalars['Int'];
};

/** Num feedback input object */
export type NumFeedbackInput = {
  metric: Scalars['String'];
  question: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  score: Scalars['Int'];
};

/** Represents the input for the printLabel API. */
export type PrintLabelInput = {
  /** Name of the printer, usually an IP address optionally combined with a port. */
  printerName: Scalars['String'];
  /** Scannable of the container to print label for. */
  scannable: Scalars['String'];
};

/** Represents the output of the printLabel API. */
export type PrintLabelOutput = {
  __typename?: 'PrintLabelOutput';
  /** Scannable of the container whose the label was printed. */
  scannable: Scalars['String'];
};

/** A root type for queries */
export type Query = {
  __typename?: 'Query';
  /** Check if given scannables have a common parent */
  areSiblings?: Maybe<AreSiblingsOutput>;
  /** Audit the container and the package count */
  childCountAudit?: Maybe<ChildCountAuditOutput>;
  getDestinationsForContainer?: Maybe<GetDestinationsForContainerOutput>;
  /** Get pending messages for the user. */
  getMessages: GetMessagesOutput;
  /** Get node configurations */
  getNodeConfig: NodeConfigOutput;
  /** Fetches a container. */
  identifyContainer?: Maybe<IdentifyContainerOutput>;
  /** Get directed container movement task */
  nextDirectedMoveTask?: Maybe<NextDirectedMoveTaskOutput>;
  /** Checks the health of the service. */
  ping: Scalars['String'];
  /** Fetches users SAM roles. */
  roles: Array<Role>;
  /** Get an updated directed container movement task */
  updatedDirectedMoveTask?: Maybe<UpdatedDirectedMoveTaskOutput>;
  /** Gets the allowed list of container types for the resource. */
  validContainerTypesForResource: ValidContainerTypesForResourceOutput;
};


/** A root type for queries */
export type QueryAreSiblingsArgs = {
  input: AreSiblingsInput;
};


/** A root type for queries */
export type QueryChildCountAuditArgs = {
  input: ChildCountAuditInput;
};


/** A root type for queries */
export type QueryGetDestinationsForContainerArgs = {
  input: GetDestinationsForContainerInput;
};


/** A root type for queries */
export type QueryIdentifyContainerArgs = {
  input: IdentifyContainerInput;
};


/** A root type for queries */
export type QueryNextDirectedMoveTaskArgs = {
  input?: InputMaybe<NextDirectedMoveTaskInput>;
};


/** A root type for queries */
export type QueryUpdatedDirectedMoveTaskArgs = {
  input?: InputMaybe<UpdatedDirectedMoveTaskInput>;
};


/** A root type for queries */
export type QueryValidContainerTypesForResourceArgs = {
  input: ValidContainerTypesForResourceInput;
};

/** Represents a SAM role. */
export type Role = {
  __typename?: 'Role';
  /** Level of the role. */
  roleLevel: RoleLevel;
  /** Name of the role. */
  roleName: RoleName;
};

/**
 * Level of a SAM role in ascending order, with LEVEL_1 being the lowest and LEVEL_4 being the highest.
 * Note: The order in which these are defined matters because their ordinal values are compared.
 */
export enum RoleLevel {
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4'
}

/** Name of a SAM role. */
export enum RoleName {
  ContainerBuilder = 'CONTAINER_BUILDER',
  ContainerUnloader = 'CONTAINER_UNLOADER',
  DirectedCptChaser = 'DIRECTED_CPT_CHASER',
  DirectedLoader = 'DIRECTED_LOADER',
  DirectedStager = 'DIRECTED_STAGER',
  DirectedWaterspider = 'DIRECTED_WATERSPIDER'
}

/** Represents a SendWebVitalsMetricInput object to send Web Vitals metrics name and value */
export type SendWebVitalsMetricInput = {
  /** Web Vitals metric name: CLS, FID, FCP, LCP, TTFB */
  name: Scalars['String'];
  /** Web Vitals metric value in milliseconds */
  value: Scalars['Int'];
};

/** Represents a SendWebVitalsMetricOutput object that contains Web Vitals metric name */
export type SendWebVitalsMetricOutput = {
  __typename?: 'SendWebVitalsMetricOutput';
  /** Web Vitals metric name: CLS, FID, FCP, LCP, TTFB */
  name: Scalars['String'];
};

/** Represents a SwapDirectedWorkInput object */
export type SwapDirectedWorkInput = {
  /** current work request id */
  currentRequestId: Scalars['String'];
  /** new work scannable id */
  newScannableId: Scalars['String'];
};

/** Represents a SwapDirectedWorkOutput object */
export type SwapDirectedWorkOutput = {
  __typename?: 'SwapDirectedWorkOutput';
  /** container id to move - UUID */
  containerId?: Maybe<Scalars['String']>;
  /** container scannable to move - also to display label */
  containerScannable?: Maybe<Scalars['String']>;
  /** container type to move */
  containerType?: Maybe<Scalars['String']>;
  /** The critical pull time. */
  cpt?: Maybe<Scalars['String']>;
  /** Label of destination resource to which source should be moved */
  destinationResourceLabel?: Maybe<Scalars['String']>;
  /** destination resource scannable id */
  destinationResourceScannableId?: Maybe<Scalars['String']>;
  /** Type of destination resource to which source should be moved */
  destinationResourceType?: Maybe<Scalars['String']>;
  /** The color of the light on the container. */
  lightColor?: Maybe<Scalars['String']>;
  /**
   * The state of the light. Possible states are: on, none, error
   * * on - The light is available and is on. See the LightColor field.
   * * none - The container does not support a light or is not installed.
   * * error - The container supports a light, but an error occurred when turning it on.
   * * unknown - The light is on, but is an unsupported color.
   */
  lightState?: Maybe<Scalars['String']>;
  /** The time the task needs to be completed. */
  needByTime?: Maybe<Scalars['String']>;
  /** The reason the task needs to be completed by the time. */
  needByTimeReason?: Maybe<Scalars['String']>;
  /** DCM task request id */
  requestId?: Maybe<Scalars['String']>;
  /** DCM task request time */
  requestTime?: Maybe<Scalars['String']>;
  /** result message */
  resultMessage: Scalars['String'];
  /** resource display label */
  sourceResourceLabel?: Maybe<Scalars['String']>;
  /** source resource scannable id */
  sourceResourceScannableId?: Maybe<Scalars['String']>;
  /** Type of resource to which source is present */
  sourceResourceType?: Maybe<Scalars['String']>;
  /** reason to move */
  workAssignmentReason?: Maybe<Scalars['String']>;
  /** work type of the dcm task */
  workType?: Maybe<Scalars['String']>;
};

export type TextFeedback = {
  __typename?: 'TextFeedback';
  /** Feedback given by associate */
  feedback: Scalars['String'];
  /** Topic selected on feedback form */
  topic: Scalars['String'];
};

/** Text feedback input object */
export type TextFeedbackInput = {
  feedback: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  topic: Scalars['String'];
};

/** Represents an UpdateMessageInput object to update the status of the message. */
export type UpdateMessageInput = {
  /** The name of the application that is updating the message. */
  clientType: Scalars['String'];
  /** Id of the message to be updated. */
  messageRecipientId: Scalars['String'];
  /**
   * Update the message to this status (PENDING, DELIVERED, CLOSED, CANCELED, EXPIRED).
   * MessageStatus reference: https://tiny.amazon.com/rbcul1af
   */
  newStatus: Scalars['String'];
};

/** Represents an UpdateMessageOutput object of the updated message. */
export type UpdateMessageOutput = {
  __typename?: 'UpdateMessageOutput';
  /** The login name (alias) of the user who updated the message. */
  clientId: Scalars['String'];
  /** The name of the application that updated the message. */
  clientType: Scalars['String'];
  /** Id of the message that was updated. */
  messageRecipientId: Scalars['String'];
  /** Status of the message after update. */
  newStatus: Scalars['String'];
};

/** Represents a UpdateWorkStatusInput object */
export type UpdateWorkStatusInput = {
  /** DCM task request id */
  requestId: Scalars['String'];
  /** update task to this status */
  statusCode: Scalars['String'];
};

/** Represents a UpdateWorkStatusOutput object */
export type UpdateWorkStatusOutput = {
  __typename?: 'UpdateWorkStatusOutput';
  /** DCM task request id */
  requestId: Scalars['String'];
  /** result message from update task */
  resultMessage: Scalars['String'];
  /** update task to this status */
  statusCode: Scalars['String'];
};

/** Represents the request payload to get updated information for a task. */
export type UpdatedDirectedMoveTaskInput = {
  /** DCM task request id */
  requestId: Scalars['String'];
};

/** Represents a UpdatedDirectedMoveTaskOutput object */
export type UpdatedDirectedMoveTaskOutput = {
  __typename?: 'UpdatedDirectedMoveTaskOutput';
  /** Label of the destination resource. */
  destinationResourceLabel?: Maybe<Scalars['String']>;
  /** ScannableId of destination resource. */
  destinationResourceScannableId?: Maybe<Scalars['String']>;
  /** Type of destination resource. */
  destinationResourceType?: Maybe<Scalars['String']>;
  /** True when the request was cancelled, otherwise false. */
  requestCancelled?: Maybe<Scalars['Boolean']>;
  /** The time the of the task cancellation. Null when there is no task cancellation. */
  requestCancelledTime?: Maybe<Scalars['String']>;
  /** DCM task request id */
  requestId: Scalars['String'];
  /**
   * True when the request was updated or changed, otherwise false.
   * To determine when there multiple updates, check and compare the requestUpdatedTime between subsequent queries.
   */
  requestUpdated?: Maybe<Scalars['Boolean']>;
  /** The time the of the last task update. Null when there is no task update. */
  requestUpdatedTime?: Maybe<Scalars['String']>;
  /** The reason the work was cancelled. */
  workCancellationReason?: Maybe<Scalars['String']>;
  /** The reason the work was updated. */
  workUpdateReason?: Maybe<Scalars['String']>;
};

/** Represents a ValidContainerTypesForResourceInput object to retrieve the list of allowed container types for the resource */
export type ValidContainerTypesForResourceInput = {
  /** Scannable for the resource. */
  scannable: Scalars['String'];
};

/** Represents a ValidContainerTypesForResourceOutput object that contains list of allowed container types for the resource */
export type ValidContainerTypesForResourceOutput = {
  __typename?: 'ValidContainerTypesForResourceOutput';
  allowedContainerTypes: Array<AllowedContainerType>;
};

/** Represents a container's volume properties, for example, current utilization. */
export type VolumeProperty = {
  __typename?: 'VolumeProperty';
  /** Container's (currentCapacity/maxCapacity). */
  currentUtilization?: Maybe<Scalars['Int']>;
  /** Container's (currentCapacity/targetCapacity). */
  targetUtilization?: Maybe<Scalars['Int']>;
};

/** Represents container's weight property. */
export type WeightProperty = {
  __typename?: 'WeightProperty';
  /** Container's current weight. */
  currentWeight?: Maybe<Scalars['Int']>;
  /** Container's weight measurement unit, for example, kg. */
  unitOfMeasurement?: Maybe<Scalars['String']>;
  /** Container's current weight utilization in percentage, utilization = currentWeight * 100 / weightLimit in perfect node */
  utilization?: Maybe<Scalars['Int']>;
};

/** Represents work. */
export type Work = {
  __typename?: 'Work';
  /** Reason behind the work. */
  assignmentReason?: Maybe<Scalars['String']>;
  /** The time the work needs to be completed. */
  needByTime?: Maybe<Scalars['String']>;
  /** Work request ID. */
  requestId?: Maybe<Scalars['String']>;
  /** Work request time. */
  requestTime?: Maybe<Scalars['String']>;
  /** The resulting message. */
  resultMessage?: Maybe<Scalars['String']>;
  /** Type of work. */
  type?: Maybe<Scalars['String']>;
};

export type AreSiblingsQueryVariables = Exact<{
  identifier: AreSiblingsInput;
}>;


export type AreSiblingsQuery = { __typename?: 'Query', areSiblings?: { __typename?: 'AreSiblingsOutput', scannable: string, containerType: string } | null };

export type IdentifyContainerQueryVariables = Exact<{
  input: IdentifyContainerInput;
  withHazmat: Scalars['Boolean'];
  withHierarchyInfo: Scalars['Boolean'];
  withAggregateProperty: Scalars['Boolean'];
}>;


export type IdentifyContainerQuery = { __typename?: 'Query', identifyContainer?: { __typename?: 'IdentifyContainerOutput', containerId: string, containerType: string, containerLabel: string, scannables: Array<string | null>, stackingFilter?: string | null, vsm?: string | null, cpt?: string | null, hazmatInfo?: { __typename?: 'HazmatInfo', hasHazmat: boolean } | null, hierarchyInfo?: { __typename?: 'ContainerHierarchyInfo', parentContainerScannable?: string | null, packageChildrenCount: number } | null, aggregateProperty?: { __typename?: 'AggregateProperty', volumeProperty?: { __typename?: 'VolumeProperty', currentUtilization?: number | null, targetUtilization?: number | null } | null, weightProperty?: { __typename?: 'WeightProperty', currentWeight?: number | null, unitOfMeasurement?: string | null, utilization?: number | null } | null } | null } | null };

export type MoveContainerMutationVariables = Exact<{
  input: MoveContainerInput;
}>;


export type MoveContainerMutation = { __typename?: 'Mutation', moveContainer?: { __typename?: 'MoveContainerOutput', sourceScannable: string, destinationScannable: string } | null };

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', roleName: RoleName, roleLevel: RoleLevel }> };

export type EmitMetricsMutationVariables = Exact<{
  input: EmitMetricsInput;
}>;


export type EmitMetricsMutation = { __typename?: 'Mutation', emitMetrics: { __typename?: 'EmitMetricsOutput', metricNames: Array<string> } };

export type SendWebVitalsMetricMutationVariables = Exact<{
  input: SendWebVitalsMetricInput;
}>;


export type SendWebVitalsMetricMutation = { __typename?: 'Mutation', sendWebVitalsMetric: { __typename?: 'SendWebVitalsMetricOutput', name: string } };

export type GetNodeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNodeConfigQuery = { __typename?: 'Query', getNodeConfig: { __typename?: 'NodeConfigOutput', nodeConfigurations: string } };


export const AreSiblingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"areSiblings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AreSiblingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areSiblings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scannable"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"}}]}}]}}]} as unknown as DocumentNode<AreSiblingsQuery, AreSiblingsQueryVariables>;
export const IdentifyContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"identifyContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdentifyContainerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withHazmat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withHierarchyInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withAggregateProperty"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifyContainer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"containerId"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"}},{"kind":"Field","name":{"kind":"Name","value":"containerLabel"}},{"kind":"Field","name":{"kind":"Name","value":"scannables"}},{"kind":"Field","name":{"kind":"Name","value":"stackingFilter"}},{"kind":"Field","name":{"kind":"Name","value":"vsm"}},{"kind":"Field","name":{"kind":"Name","value":"cpt"}},{"kind":"Field","name":{"kind":"Name","value":"hazmatInfo"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withHazmat"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasHazmat"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hierarchyInfo"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withHierarchyInfo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentContainerScannable"}},{"kind":"Field","name":{"kind":"Name","value":"packageChildrenCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateProperty"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withAggregateProperty"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"volumeProperty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUtilization"}},{"kind":"Field","name":{"kind":"Name","value":"targetUtilization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightProperty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitOfMeasurement"}},{"kind":"Field","name":{"kind":"Name","value":"utilization"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IdentifyContainerQuery, IdentifyContainerQueryVariables>;
export const MoveContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moveContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveContainerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveContainer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceScannable"}},{"kind":"Field","name":{"kind":"Name","value":"destinationScannable"}}]}}]}}]} as unknown as DocumentNode<MoveContainerMutation, MoveContainerMutationVariables>;
export const GetUserRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleName"}},{"kind":"Field","name":{"kind":"Name","value":"roleLevel"}}]}}]}}]} as unknown as DocumentNode<GetUserRolesQuery, GetUserRolesQueryVariables>;
export const EmitMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"emitMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmitMetricsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emitMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricNames"}}]}}]}}]} as unknown as DocumentNode<EmitMetricsMutation, EmitMetricsMutationVariables>;
export const SendWebVitalsMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendWebVitalsMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendWebVitalsMetricInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendWebVitalsMetric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SendWebVitalsMetricMutation, SendWebVitalsMetricMutationVariables>;
export const GetNodeConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNodeConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNodeConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeConfigurations"}}]}}]}}]} as unknown as DocumentNode<GetNodeConfigQuery, GetNodeConfigQueryVariables>;